import React, { Component } from 'react';
import clsx from 'clsx';
//import { makeStyles } from '@material-ui/core/styles';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import { Field, reduxForm } from 'redux-form';
import { Grid, Button } from '@material-ui/core';
import RenderTextFieldReduxMin from '../Complements/RenderTextFieldReduxMin';
import 'react-nice-input-password/dist/react-nice-input-password.css';
import PasswordConditionsIndicator from '../Complements/PasswordConditionsIndicator';
import PasswordBarLineIndicator from '../Complements/PasswordBarLineIndicator';


const validate = values => {
    //console.log(values)
    const error  = {}
    
    if (values.passwordRepeat !== values.passwordNew) {
        error.passwordNew = "Las contraseñas no coinciden"
        error.passwordRepeat = "Las contraseñas no coinciden"
    }
    return error
}


class ChangePasswordForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: "",
            progressBarColors: ["#EFEFEF", "red", "orange", "yellow", "#C9FF37", "green"]
        }
    }

    handleChange = (data) => {
        this.setState({
            value : data.value
        })
    }

    render() {
        const { classes, handleSubmit,  valid, submitting, handleChangePasswordNew, handleChangeRepeatPassword, handleChangeOldPassword, numberValid, uppercaseValid, lowercaseValid, specialCharValid, charNumberValid, progress, oldPassword, passwordRepeat } = this.props;
        //console.log("props: ", this.props)
        const { progressBarColors  } = this.state;
        return (
                <form  onSubmit={ handleSubmit } autoComplete={false}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                        <Field
                                name="oldPassword"
                                id="oldPassword"
                                required
                                allowZero = {true}
                                className={clsx(classes.margin, classes.textField)}
                                component={ RenderTextFieldReduxMin }
                                label="DIGITE su contraseña anterior"
                                type="password"
                                fullWidth
                                onChange={handleChangeOldPassword}
                                
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                        <Field
                                name="passwordNew"
                                id="passwordNew"
                                required
                                className={clsx(classes.margin, classes.textField)}
                                onChange={handleChangePasswordNew}
                                component={ RenderTextFieldReduxMin } 
                                label="DIGITE su nueva contraseña"
                                type="password"
                                fullWidth />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Field
                                name="passwordRepeat"
                                id="passwordRepeat"
                                required
                                allowZero = {true}
                                className={clsx(classes.margin, classes.textField)}
                                component={ RenderTextFieldReduxMin }
                                label="REPITA su nueva contraseña"
                                type="password"
                                fullWidth
                                onChange={handleChangeRepeatPassword}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <PasswordBarLineIndicator progress = {progress} progresscolor = {progressBarColors[progress/20]} />
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <PasswordConditionsIndicator
                                numberValid = { numberValid }
                                uppercaseValid = { uppercaseValid }
                                lowercaseValid = { lowercaseValid }
                                specialCharValid = { specialCharValid }
                                charNumberValid = { charNumberValid }
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Button 
                                variant="contained" 
                                type="submit"
                                disabled={!valid || submitting || !numberValid || !uppercaseValid || !lowercaseValid || !specialCharValid || !charNumberValid || (oldPassword.length === 0) ? true : false || (passwordRepeat.length === 0) ? true : false }
                                size = { "large"}
                            >
                                Aceptar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
        );
    }
}

ChangePasswordForm.propTypes = {

};

const ChangePasswordReduxForm = reduxForm(
    {
        form: 'ChangePasswordForm',
        validate
    }
)(ChangePasswordForm)

// export default ChangePasswordForm;
export default setPropsAsInitial(ChangePasswordReduxForm)